/* eslint-disable no-unused-vars */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import InfoIconImg from 'src/assets/benefits-important.svg';
import BenefitsCart, { ReactComponent as BenefitsCartIcon } from 'src/assets/benefits-cart.svg';
import { ReactComponent as BenefitsAvailableIcon } from 'src/assets/benefits-available.svg';

import { AlertAdapter, FullScreenLoading, RegularButton } from 'pg-ui-library';
import { useTypedSelector } from 'src/hooks/useTypedSelector';

import { useActions } from 'src/hooks/useActions';
import { monetaryUSDFormat } from 'src/utils/currencyFormat';

import { IBenefit, ICartBenefit } from 'src/interfaces';

import { useQuery } from '@tanstack/react-query';
import benefitsService from 'src/services/benefits.service';
import {
  Container,
  Header,
  HeaderTitle,
  Content,
  HeaderItemLeft,
  HeaderItemRight,
  CancelButton,
  InfoIconContainer,
  InfoIcon,
  TooltipText,
  RelativeContainer,
  ScrollableContainer,
  ScrollableContainerEmpty,
  CartFooter,
  CartFooterText,
  CartContainer,
  LeftGridContent,
  RightGridContent,
  HeaderDaysLeft,
} from './styles';
import AvailableBenefitsCard from '../available-benefits-card';
import EnrollmentChanges from '../enrollment-changes';
import CartTabs from '../cart-tabs';

import { EnrollSelectionModal } from '../enroll-selection-modal';
import { StoreContextProvider } from '../../enrollment.context';
import { BenefitEventType } from '../..';

const NewHire: React.FC = () => {
  const { t } = useTranslation();
  const { getPersonalInfo, getCartSession, setBenefitEnrollmentType } = useActions();
  const [mandatoryBenefits] = useState<IBenefit[]>();
  const { addBenefitToCart } = useActions();
  const { data: freePlans, isLoading: loadingFreePlans } = useQuery({
    queryKey: ['benefits/free-plans'],
    queryFn: () => benefitsService.getFreePlans(BenefitEventType.NEW_HIRE),
    enabled: true,
  });
  const { loading } = useTypedSelector(state => state.benefits);
  const { cart, benefits, daysToEndMonth, fetchingCartSession, isNewHire } = useTypedSelector(
    state => state.benefits.data
  );
  const isEmpty = cart ? cart?.length <= 0 : true;

  const totalAddedToCart = cart
    ?.filter(benefit => benefit.action === 'ADD')
    ?.map(benefit => benefit.price)
    .reduce((acc, next) => Number(acc) + Number(next), 0) as unknown as 0;

  const navigate = useNavigate();

  useEffect(() => {
    setBenefitEnrollmentType('new_hire');
    getPersonalInfo();
    getCartSession(BenefitEventType.NEW_HIRE);
  }, []);

  useEffect(() => {
    if (!fetchingCartSession) {
      if (freePlans && freePlans.length > 0) {
        freePlans.forEach((freePlan: IBenefit) => {
          const freeBenefit: ICartBenefit = {
            generalCategory: freePlan.generalCategory,
            type: freePlan.type || '',
            benefitId: freePlan.benefitId,
            imgURL: freePlan.imgURL,
            planDescription: freePlan.type || '',
            optionDescription: freePlan.optionDescription,
            price: 0,
            expiration: freePlan.expiration,
            action: 'ADD',
            benefitName: freePlan.type || '',
            benefitPlanId: freePlan.benefitPlanId,
            benefitOptionId: freePlan.benefitOptionId,
            benefitEnrollmentStart: freePlan.benefitEnrollmentStart,
            benefitEnrollmentEnd: freePlan.benefitEnrollmentEnd,
            benefitProvider: freePlan.benefitProvider,
            employeeName: freePlan.employeeName,
            employeeCost: 0,
            employerName: freePlan.employerName,
            employerCost: 0,
            percent: 0,
            fixedAmount: 0,
            dependents: '',
            employeeChoosesPayment: null,
            costCalculationMethod: freePlan.costCalculationMethod,
          };
          addBenefitToCart({ ...freeBenefit });
        });
      }
    }
  }, [freePlans]);

  const startReview = () => {
    if (!isNewHire) {
      AlertAdapter('Enrollment available just for new hire', 'error');
      return;
    }
    const stateData = { event: 'new_hire' };

    navigate('/benefits/review', { state: stateData });
  };

  return (
    <Container>
      {(loading || fetchingCartSession || loadingFreePlans) && <FullScreenLoading />}
      <Header>
        <HeaderItemLeft>
          <HeaderTitle>{t('benefits.newHire.title')}</HeaderTitle>
          <HeaderDaysLeft>
            {t('benefits.newHire.daysLeft')} {daysToEndMonth}
          </HeaderDaysLeft>
          <InfoIconContainer>
            <RelativeContainer id="tooltip">
              <TooltipText>{t('benefits.newHire.balloon', { days: daysToEndMonth })}</TooltipText>
            </RelativeContainer>
            <InfoIcon src={InfoIconImg} />
          </InfoIconContainer>
        </HeaderItemLeft>
        <HeaderItemRight>
          <CancelButton onClick={() => navigate('/benefits', { replace: true })}>
            {t('global.form.cancel')}
          </CancelButton>
        </HeaderItemRight>
      </Header>
      <Content>
        <LeftGridContent>
          <EnrollmentChanges eventType="new_hire" />
          <EnrollSelectionModal eventType={BenefitEventType.NEW_HIRE} />
        </LeftGridContent>
        <RightGridContent>
          <CartTabs
            firstTabTitle="Active"
            FirstTabIcon={BenefitsAvailableIcon}
            secondTabTitle="Cart"
            SecondTabIcon={BenefitsCartIcon}
            FirstTabContent={() => (
              <ScrollableContainer>
                {benefits.map((benefit, index) => (
                  <AvailableBenefitsCard
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    benefitId={benefit.benefitId}
                    imgURL={benefit.imgURL}
                    title={benefit.benefitName}
                    subtitle={
                      benefit.dependentsDescription
                        ? benefit.dependentsDescription
                        : benefit.optionDescription || benefit.benefitOptionId
                    }
                    fee={monetaryUSDFormat(benefit.fixedAmount || benefit.employeeCost)}
                    date={benefit.benefitEnrollmentEnd}
                    editMode={false}
                    deleteMode={false}
                  />
                ))}
              </ScrollableContainer>
            )}
            SecondTabContent={() => (
              <>
                {isEmpty && mandatoryBenefits?.length === 0 ? (
                  <ScrollableContainerEmpty>
                    <img src={BenefitsCart} />
                    <h3 style={{ margin: 0 }}>{t('benefits.newHire.emptyCart.line1')}</h3>
                    <p style={{ margin: 0 }}>{t('benefits.newHire.emptyCart.line2')}</p>
                    <p style={{ margin: 0 }}>{t('benefits.newHire.emptyCart.line3')}</p>
                  </ScrollableContainerEmpty>
                ) : (
                  <CartContainer>
                    <ScrollableContainer>
                      {cart?.map((benefit, index) => (
                        <AvailableBenefitsCard
                          // eslint-disable-next-line react/no-array-index-key
                          key={index}
                          type={benefit.type}
                          benefitId={benefit.benefitId}
                          imgURL={benefit.imgURL}
                          title={benefit.planDescription}
                          subtitle={
                            benefit.dependentsDescription ? benefit.dependentsDescription : benefit.optionDescription
                          }
                          fee={monetaryUSDFormat(benefit.price)}
                          date={benefit.expiration}
                          editMode={benefit.costCalculationMethod?.toLowerCase() !== 'free'}
                          deleteMode={benefit.costCalculationMethod?.toLowerCase() !== 'free'}
                          mandatory={false}
                        />
                      ))}
                    </ScrollableContainer>
                    <CartFooter>
                      <RegularButton onClick={startReview} disabled={!isNewHire}>
                        {t('global.form.continue')}
                      </RegularButton>
                      <CartFooterText>
                        {t('benefits.newHire.totalOnCart')}: {monetaryUSDFormat(totalAddedToCart ?? 0)}
                      </CartFooterText>
                    </CartFooter>
                  </CartContainer>
                )}
              </>
            )}
          />
        </RightGridContent>
      </Content>
    </Container>
  );
};

const NewHireStoreWrapper: React.FC = () => (
  <StoreContextProvider>
    <NewHire />
  </StoreContextProvider>
);
export default NewHireStoreWrapper;
